import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'PriceTypeTemplate',
    column_type: 'id',
  },
  created_at: {
    model_name: 'PriceTypeTemplate',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'PriceTypeTemplate',
    column_type: 'datetime',
  },
  name: {
    model_name: 'PriceTypeTemplate',
    column_type: 'string',
  },
  price_types: {
    model_name: 'PriceTypeTemplate',
    column_type: 'has_many',
    extra: {
      association_name: 'price_types',
      model_name: 'PriceType',
      foreign_key: 'price_type_template_id',
    },
  },
  price_type_ids: {
    model_name: 'PriceTypeTemplate',
    column_type: 'has_many',
    extra: {
      association_name: 'price_types',
      model_name: 'PriceType',
      foreign_key: 'price_type_template_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
